import { FlightsClassTypes, FlightsFareTypes, FlightViewTypes } from 'constants/flight'
import type { FlightSearchParams } from 'hooks/useSearchFlights'

/**
 * Temporary search inputs for the isolated tour flight upsell.
 * Sydney → Bali, then Phuket → Sydney exercises different tour endpoints.
 * Dates are fixed departure dates; refresh them before they leave the booking window.
 * Membership eligibility and currency remain responsibilities of the existing checkout.
 */
export const TOUR_FLIGHT_SEARCH_FIXTURE = {
  departing: {
    itinerary: [{
      departureAirport: 'SYD',
      arrivalAirport: 'DPS',
      departureDate: '2027-03-10',
    }],
    occupancies: [{ adults: 2, children: 0, infants: 0 }],
    fareClass: FlightsClassTypes.ECONOMY,
    fareType: FlightsFareTypes.ONE_WAY,
    viewType: FlightViewTypes.ONE_WAY,
  },
  returning: {
    itinerary: [{
      departureAirport: 'HKT',
      arrivalAirport: 'SYD',
      departureDate: '2027-03-22',
    }],
    occupancies: [{ adults: 2, children: 0, infants: 0 }],
    fareClass: FlightsClassTypes.ECONOMY,
    fareType: FlightsFareTypes.ONE_WAY,
    viewType: FlightViewTypes.ONE_WAY,
  },
} satisfies Record<'departing' | 'returning', FlightSearchParams>
